import { customColumnType } from "../../../zero-data-transformer/src/column-transforms";

const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;

const temporalInstantColumnBuilder = customColumnType({
  base: "number",
  encode(value: Temporal.Instant) {
    return value.epochMilliseconds;
  },
  decode(value: number) {
    return Temporal.Instant.fromEpochMilliseconds(value);
  },
});

const temporalDateColumnBuilder = customColumnType({
  base: "number",
  encode(value: Temporal.PlainDate) {
    return value.toZonedDateTime("UTC").epochMilliseconds;
  },
  decode(value: number) {
    return Temporal.Instant.fromEpochMilliseconds(value).toZonedDateTimeISO("UTC").toPlainDate();
  },
});

const temporalTimeColumnBuilder = customColumnType({
  base: "number",
  encode(value: Temporal.PlainTime) {
    return value.since(Temporal.PlainTime.from("00:00")).total("millisecond");
  },
  decode(value: number) {
    if (!Number.isInteger(value) || value < 0 || value >= MILLISECONDS_PER_DAY) {
      throw new RangeError("Time value must be an integer number of milliseconds since midnight");
    }

    const hour = Math.floor(value / (60 * 60 * 1000));
    const minute = Math.floor((value % (60 * 60 * 1000)) / (60 * 1000));
    const second = Math.floor((value % (60 * 1000)) / 1000);
    const millisecond = value % 1000;

    return Temporal.PlainTime.from({ hour, minute, second, millisecond });
  },
});

export const temporalInstantColumn = () => temporalInstantColumnBuilder();

export const temporalDateColumn = () => temporalDateColumnBuilder();

export const temporalTimeColumn = () => temporalTimeColumnBuilder();
